import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_COUNTRY} from '../../../utils/DropdownOptionPropsUtils';

export const countryResource: DropdownOptionProps[] = [
    { name: SELECT_COUNTRY, value: SELECT_COUNTRY },
    { name: 'Afghanistan', value: 'AF' },
    { name: 'Albania', value: 'AL' },
    { name: 'Algeria', value: 'DZ' },
    { name: 'Andorra', value: 'AD' },
    { name: 'Angola', value: 'AO' },
    { name: 'Antigua_and_Barbuda', value: 'AG' },
    { name: 'Argentina', value: 'AR' },
    { name: 'Armenia', value: 'AM' },
    { name: 'Australia', value: 'AU' },
    { name: 'Austria', value: 'AT' },
    { name: 'Azerbaijan', value: 'AZ' },
    { name: 'Bahamas', value: 'BS' },
    { name: 'Bahrain', value: 'BH' },
    { name: 'Bangladesh', value: 'BD' },
    { name: 'Barbados', value: 'BB' },
    { name: 'Belarus', value: 'BY' },
    { name: 'Belgium', value: 'BE' },
    { name: 'Belize', value: 'BZ' },
    { name: 'Benin', value: 'BJ' },
    { name: 'Bhutan', value: 'BT' },
    { name: 'Bolivia', value: 'BO' },
    { name: 'Bosnia_and_Herzegovina', value: 'BA' },
    { name: 'Botswana', value: 'BW' },
    { name: 'Brazil', value: 'BR' },
    { name: 'Brunei', value: 'BN' },
    { name: 'Bulgaria', value: 'BG' },
    { name: 'Burkina_Faso', value: 'BF' },
    { name: 'Burundi', value: 'BI' },
    { name: 'Cabo_Verde', value: 'CV' },
    { name: 'Cambodia', value: 'KH' },
    { name: 'Cameroon', value: 'CM' },
    { name: 'Canada', value: 'CA' },
    { name: 'Central_African_Republic', value: 'CF' },
    { name: 'Chad', value: 'TD' },
    { name: 'Chile', value: 'CL' },
    { name: 'China', value: 'CN' },
    { name: 'Colombia', value: 'CO' },
    { name: 'Comoros', value: 'KM' },
    { name: 'Congo_(Congo-Brazzaville)', value: 'CG' },
    { name: 'Costa_Rica', value: 'CR' },
    { name: 'Croatia', value: 'HR' },
    { name: 'Cuba', value: 'CU' },
    { name: 'Cyprus', value: 'CY' },
    { name: 'Czechia', value: 'CZ' },
    { name: 'Democratic_Republic_of_the_Congo', value: 'CD' },
    { name: 'Denmark', value: 'DK' },
    { name: 'Djibouti', value: 'DJ' },
    { name: 'Dominica', value: 'DM' },
    { name: 'Dominican_Republic', value: 'DO' },
    { name: 'Ecuador', value: 'EC' },
    { name: 'Egypt', value: 'EG' },
    { name: 'El_Salvador', value: 'SV' },
    { name: 'Equatorial_Guinea', value: 'GQ' },
    { name: 'Eritrea', value: 'ER' },
    { name: 'Estonia', value: 'EE' },
    { name: 'Eswatini', value: 'SZ' },
    { name: 'Ethiopia', value: 'ET' },
    { name: 'Fiji', value: 'FJ' },
    { name: 'Finland', value: 'FI' },
    { name: 'France', value: 'FR' },
    { name: 'Gabon', value: 'GA' },
    { name: 'Gambia', value: 'GM' },
    { name: 'Georgia', value: 'GE' },
    { name: 'Germany', value: 'DE' },
    { name: 'Ghana', value: 'GH' },
    { name: 'Greece', value: 'GR' },
    { name: 'Grenada', value: 'GD' },
    { name: 'Guatemala', value: 'GT' },
    { name: 'Guinea', value: 'GN' },
    { name: 'Guinea-Bissau', value: 'GW' },
    { name: 'Guyana', value: 'GY' },
    { name: 'Haiti', value: 'HT' },
    { name: 'Honduras', value: 'HN' },
    { name: 'Hungary', value: 'HU' },
    { name: 'Iceland', value: 'IS' },
    { name: 'India', value: 'IN' },
    { name: 'Indonesia', value: 'ID' },
    { name: 'Iran', value: 'IR' },
    { name: 'Iraq', value: 'IQ' },
    { name: 'Ireland', value: 'IE' },
    { name: 'Israel', value: 'IL' },
    { name: 'Italy', value: 'IT' },
    { name: 'Jamaica', value: 'JM' },
    { name: 'Japan', value: 'JP' },
    { name: 'Jordan', value: 'JO' },
    { name: 'Kazakhstan', value: 'KZ' },
    { name: 'Kenya', value: 'KE' },
    { name: 'Kiribati', value: 'KI' },
    { name: 'Kuwait', value: 'KW' },
    { name: 'Kyrgyzstan', value: 'KG' },
    { name: 'Laos', value: 'LA' },
    { name: 'Latvia', value: 'LV' },
    { name: 'Lebanon', value: 'LB' },
    { name: 'Lesotho', value: 'LS' },
    { name: 'Liberia', value: 'LR' },
    { name: 'Libya', value: 'LY' },
    { name: 'Liechtenstein', value: 'LI' },
    { name: 'Lithuania', value: 'LT' },
    { name: 'Luxembourg', value: 'LU' },
    { name: 'Madagascar', value: 'MG' },
    { name: 'Malawi', value: 'MW' },
    { name: 'Malaysia', value: 'MY' },
    { name: 'Maldives', value: 'MV' },
    { name: 'Mali', value: 'ML' },
    { name: 'Malta', value: 'MT' },
    { name: 'Marshall_Islands', value: 'MH' },
    { name: 'Mauritania', value: 'MR' },
    { name: 'Mauritius', value: 'MU' },
    { name: 'Mexico', value: 'MX' },
    { name: 'Micronesia', value: 'FM' },
    { name: 'Moldova', value: 'MD' },
    { name: 'Monaco', value: 'MC' },
    { name: 'Mongolia', value: 'MN' },
    { name: 'Montenegro', value: 'ME' },
    { name: 'Morocco', value: 'MA' },
    { name: 'Mozambique', value: 'MZ' },
    { name: 'Myanmar_(Burma)', value: 'MM' },
    { name: 'Namibia', value: 'NA' },
    { name: 'Nauru', value: 'NR' },
    { name: 'Nepal', value: 'NP' },
    { name: 'Netherlands', value: 'NL' },
    { name: 'New_Zealand', value: 'NZ' },
    { name: 'Nicaragua', value: 'NI' },
    { name: 'Niger', value: 'NE' },
    { name: 'Nigeria', value: 'NG' },
    { name: 'North_Korea', value: 'KP' },
    { name: 'North_Macedonia', value: 'MK' },
    { name: 'Norway', value: 'NO' },
    { name: 'Oman', value: 'OM' },
    { name: 'Pakistan', value: 'PK' },
    { name: 'Palau', value: 'PW' },
    { name: 'Palestine_State', value: 'PS' },
    { name: 'Panama', value: 'PA' },
    { name: 'Papua_New_Guinea', value: 'PG' },
    { name: 'Paraguay', value: 'PY' },
    { name: 'Peru', value: 'PE' },
    { name: 'Philippines', value: 'PH' },
    { name: 'Poland', value: 'PL' },
    { name: 'Portugal', value: 'PT' },
    { name: 'Qatar', value: 'QA' },
    { name: 'Romania', value: 'RO' },
    { name: 'Russia', value: 'RU' },
    { name: 'Rwanda', value: 'RW' },
    { name: 'Saint_Kitts_and_Nevis', value: 'KN' },
    { name: 'Saint_Lucia', value: 'LC' },
    { name: 'Saint_Vincent_and_the_Grenadines', value: 'VC' },
    { name: 'Samoa', value: 'WS' },
    { name: 'San_Marino', value: 'SM' },
    { name: 'Sao_Tome_and_Principe', value: 'ST' },
    { name: 'Saudi_Arabia', value: 'SA' },
    { name: 'Senegal', value: 'SN' },
    { name: 'Serbia', value: 'RS' },
    { name: 'Seychelles', value: 'SC' },
    { name: 'Sierra_Leone', value: 'SL' },
    { name: 'Singapore', value: 'SG' },
    { name: 'Slovakia', value: 'SK' },
    { name: 'Slovenia', value: 'SI' },
    { name: 'Solomon_Islands', value: 'SB' },
    { name: 'Somalia', value: 'SO' },
    { name: 'South_Africa', value: 'ZA' },
    { name: 'South_Korea', value: 'KR' },
    { name: 'South_Sudan', value: 'SS' },
    { name: 'Spain', value: 'ES' },
    { name: 'Sri_Lanka', value: 'LK' },
    { name: 'Sudan', value: 'SD' },
    { name: 'Suriname', value: 'SR' },
    { name: 'Sweden', value: 'SE' },
    { name: 'Switzerland', value: 'CH' },
    { name: 'Syria', value: 'SY' },
    { name: 'Tajikistan', value: 'TJ' },
    { name: 'Tanzania', value: 'TZ' },
    { name: 'Thailand', value: 'TH' },
    { name: 'Timor-Leste', value: 'TL' },
    { name: 'Togo', value: 'TG' },
    { name: 'Tonga', value: 'TO' },
    { name: 'Trinidad_and_Tobago', value: 'TT' },
    { name: 'Tunisia', value: 'TN' },
    { name: 'Turkey', value: 'TR' },
    { name: 'Turkmenistan', value: 'TM' },
    { name: 'Tuvalu', value: 'TV' },
    { name: 'Uganda', value: 'UG' },
    { name: 'Ukraine', value: 'UA' },
    { name: 'United_Arab_Emirates', value: 'AE' },
    { name: 'United_Kingdom', value: 'GB' },
    { name: 'United_States_of_America', value: 'US' },
    { name: 'Uruguay', value: 'UY' },
    { name: 'Uzbekistan', value: 'UZ' },
    { name: 'Vanuatu', value: 'VU' },
    { name: 'Vatican_City', value: 'VA' },
    { name: 'Venezuela', value: 'VE' },
    { name: 'Vietnam', value: 'VN' },
    { name: 'Yemen', value: 'YE' },
    { name: 'Zambia', value: 'ZM' },
    { name: 'Zimbabwe', value: 'ZW' },
    { name: 'Aland_Islands', value: 'AX' },
    { name: 'American_Samoa', value: 'AS' },
    { name: 'Anguilla', value: 'AI' },
    { name: 'Antarctica', value: 'AQ' },
    { name: 'Aruba', value: 'AW' },
    { name: 'Bermuda', value: 'BM' },
    { name: 'Bonaire,_Sint_Eustatius_and_Saba', value: 'BQ' },
    { name: 'Bouvet_Island', value: 'BV' },
    { name: 'British_Indian_Ocean_Territory', value: 'IO' },
    { name: 'Cayman_Islands', value: 'KY' },
    { name: 'Christmas_Island', value: 'CX' },
    { name: 'Cocos_(Keeling)_Islands', value: 'CC' },
    { name: 'Cook_Islands', value: 'CK' },
    { name: 'Curacao', value: 'CW' },
    { name: 'Falkland_Islands', value: 'FK' },
    { name: 'Faroe_Islands', value: 'FO' },
    { name: 'French_Guiana', value: 'GF' },
    { name: 'French_Polynesia', value: 'PF' },
    { name: 'French_Southern_Territories', value: 'TF' },
    { name: 'Gibraltar', value: 'GI' },
    { name: 'Greenland', value: 'GL' },
    { name: 'Guadeloupe', value: 'GP' },
    { name: 'Guam', value: 'GU' },
    { name: 'Guernsey', value: 'GG' },
    { name: 'Heard_Island_and_McDonald_Islands', value: 'HM' },
    { name: 'Hong_Kong', value: 'HK' },
    { name: 'Isle_of_Man', value: 'IM' },
    { name: 'Jersey', value: 'JE' },
    { name: 'Kosovo', value: 'XK' },
    { name: 'Macao', value: 'MO' },
    { name: 'Martinique', value: 'MQ' },
    { name: 'Mayotte', value: 'YT' },
    { name: 'Montserrat', value: 'MS' },
    { name: 'New_Caledonia', value: 'NC' },
    { name: 'Niue', value: 'NU' },
    { name: 'Norfolk_Island', value: 'NF' },
    { name: 'Northern_Mariana_Islands', value: 'MP' },
    { name: 'Pitcairn', value: 'PN' },
    { name: 'Puerto_Rico', value: 'PR' },
    { name: 'Reunion', value: 'RE' },
    { name: 'Saint_Barthelemy', value: 'BL' },
    { name: 'Saint_Helena,_Ascension_and_Tristan_Da_Cunha', value: 'SH' },
    { name: 'Saint_Martin', value: 'MF' },
    { name: 'Saint_Pierre_and_Miquelon', value: 'PM' },
    { name: 'Sint_Maarten', value: 'SX' },
    { name: 'South_Georgia_and_the_South_Sandwich_Islands', value: 'GS' },
    { name: 'Svalbard_and_Jan_Mayen', value: 'SJ' },
    { name: 'Taiwan', value: 'TW' },
    { name: 'Tokelau', value: 'TK' },
    { name: 'Turks_and_Caicos_Islands', value: 'TC' },
    { name: 'United_States_Minor_Outlying_Islands', value: 'UM' },
    { name: 'Virgin_Islands,_British', value: 'VG' },
    { name: 'Virgin_Islands,_U.S.', value: 'VI' },
    { name: 'Wallis_and_Futuna', value: 'WF' },
    { name: 'Western_Sahara', value: 'EH' },
    { name: 'World', value: 'WW' },
    { name: 'Cross_Country', value: 'XC' }
];
